import React, { Fragment, useEffect, useState } from "react";
import xml2js from "xml2js";

export const XmlViewer = ({ url }) => {
  const [xmlData, setXmlData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchXmlData = async (url) => {
      try {
        const response = await fetch(url);
        const text = await response.text();
        // setXmlData(text);
        xml2js.parseString(text, (err, result) => {
          if (err) {
            console.error("Failed to parse XML", err);
            setError(err);
          } else {
            console.log(result);
            setXmlData(result);
          }
        });
      } catch (error) {
        console.error("Error fetching xml file:", error);
        setError(error);
      }
    };

    fetchXmlData(url);

    return () => {
      isMounted = false;
    };
  }, [url]);

  const DisplayXmlData = ({ data }) => {
    return typeof data === "string" ? (
      <p>
        <b>{data}</b>
      </p>
    ) : (
      Object.keys(data).map((key, index) => (
        <Fragment key={index}>
          <div style={{ width: "100%" }} className="d-flex">
            {/* <p>{key}:</p> */}
            <div>
              {Array.isArray(data[key]) ? (
                <div>
                  {data[key].map((d, i) => (
                    <DisplayXmlData data={d} key={i} />
                  ))}
                </div>
              ) : typeof data[key] === "object" ? (
                <DisplayXmlData data={data[key]} />
              ) : (
                <p>
                  {key}: <b>{data[key]}</b>
                </p>
              )}
            </div>
          </div>
        </Fragment>
      ))
    );
  };

  return xmlData ? (
    <DisplayXmlData data={xmlData} />
  ) : (
    <div className="d-flex hg-100 align-content-center">{error ? "Couldn't parse this XML file." : "Loading..."}</div>
  );
};
